import * as React from 'react';
import { OrderSummarySection } from './order-summary-section';
import StaticData, { StaticDataGroup } from 'ted-ui/build/StaticData';
import { IOrderDetailsProps } from '@applications/order-tracker/config/order-tracker-new-common/types'
import { OrderTimingSectionLabels } from '@applications/order-tracker/config/order-tracker-new-common/constants';

export const OrderTimingSection = ({orderSummary}: IOrderDetailsProps) => {
    if (!orderSummary) {
        return null
    }
    const getGroupOfDescs = (): React.ReactNode => (
        <StaticDataGroup id="order-timing-group-data">
            <StaticData
                id="static-data-test"
                value={orderSummary.orderStatus}
                name={OrderTimingSectionLabels.Status}
            />
            {orderSummary.orderStatus === 'Closed' ?
                <StaticData
                    id="static-data-test"
                    name={OrderTimingSectionLabels.OrderCompletedLable}
                    value={orderSummary.orderCompletedDate}
                /> :
                <StaticData
                    helpText={OrderTimingSectionLabels.HelperText}
                    id="static-data-test"
                    name={OrderTimingSectionLabels.EstimatedCompletionLable}
                    value={orderSummary?.estimatedCompletionDate}
                />}

        </StaticDataGroup>
    );
    return (
        <OrderSummarySection
            title={OrderTimingSectionLabels.Title}
            descriptionGroup={getGroupOfDescs()}
        />
    )
};
